export default "__VITE_ASSET__CCUUSerQ__"